import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import UIImage from 'UIComponents/image/UIImage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import I18n from 'I18n';
import OneClickSyncButton from '../OneClickSync/OneClickSyncButton';
import { getIsEnglishLangUser } from '../../utils/langUtils';
// @ts-expect-error png image
import googleOauthPermissionWarningSrc from 'bender-url!../../../images/google-oauth-permission-warning-en.png';
import { DataSyncOptionApp } from '../../constants/types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GoogleDataSyncContactPermissionsWarningDialog = ({
  rootNode,
  onClose,
  onSyncClick,
  onAuthenticationSuccess,
  onAuthenticationError
}) => {
  const isEnglishLangUser = getIsEnglishLangUser();
  return /*#__PURE__*/_jsxs(UIModal, {
    "data-test-id": "google-data-sync-contact-permissions-warning-dialog",
    use: "conversational",
    rootNode: rootNode,
    width: 600,
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "growthDataModal.oneClickSync.google-contacts-permission-warning.title"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "600",
        children: isEnglishLangUser ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "growthDataModal.oneClickSync.google-contacts-permission-warning.screenshot-description"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "growthDataModal.oneClickSync.google-contacts-permission-warning.description"
        })
      }), isEnglishLangUser && /*#__PURE__*/_jsx(View, {
        boxShadow: "400",
        children: /*#__PURE__*/_jsx(UIImage, {
          alt: I18n.text('growthDataModal.oneClickSync.google-contacts-permission-warning.screenshot-alt'),
          src: googleOauthPermissionWarningSrc
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsx(OneClickSyncButton, {
        app: DataSyncOptionApp.Gmail,
        buttonType: "loading",
        "data-test-id": "google-data-sync-contact-permissions-warning-dialog-cta",
        onAuthenticationSuccess: onAuthenticationSuccess,
        onAuthenticationError: onAuthenticationError,
        onClick: onSyncClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "growthDataModal.oneClickSync.google-contacts-permission-warning.cta"
        })
      })
    })]
  });
};
export default GoogleDataSyncContactPermissionsWarningDialog;